// extracted by mini-css-extract-plugin
export default {"ChartBox":"Chart_ChartBox__vWkcn"};